import React, { useState, forwardRef, useImperativeHandle } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';

import axios from 'axios';

const DrpCategories = forwardRef((props, ref) => {

    //#region const

    const [List, setList] = useState([]);
    const [ShowLoader, setShowLoader] = useState(false);
    //#endregion

    //#region Methods

    useImperativeHandle(ref, () => ({
        Get(ProjectId) {
            if (!ProjectId || ProjectId === General.GuidEmpty()) {
                setList([]);
                return;
            }
            setShowLoader(true);
            var RequestOption = {
                method: "Get",
                url: General.ApiRoute() + "/Category/GetByProjectId",
                headers: {
                    ApiKey: process.env.REACT_APP_APIKEY,
                    ProjectId: ProjectId
                },
                withCredentials: true
            }

            axios(RequestOption)
                .then(function (res) {
                    setList(res.data);
                    setShowLoader(false);
                })
                .catch(() => {
                    setList([]);
                    setShowLoader(false);
                })
        }
    }))

    //#endregion

    return (
        <rsuite.SelectPicker
            className="mb-2 w-100"
            loading={ShowLoader}
            data={List}
            labelKey="title"
            valueKey="id"
            value={props.value}
            onChange={value => props.onSelect(value)}
            disabled={props.disabled}
            placeholder="انتخاب کنید"
        />
    );
});

export default DrpCategories;
